import { render, staticRenderFns } from "./loseOrderInfo.vue?vue&type=template&id=2077302a&scoped=true&"
import script from "./loseOrderInfo.vue?vue&type=script&lang=js&"
export * from "./loseOrderInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077302a",
  null
  
)

export default component.exports